import { Check, Error } from "@mui/icons-material";
import { Badge } from "@deere/fuel-react";
import CircularProgressWithLabel from "../../../common/data-grid/circularProgressWithLabel";

export const columns = [
  {
    accessorKey: "batchRequestId",
    header: "Batch Request ID",
  },
  {
    accessorKey: "lastUpdate",
    header: "Last Update",
  },
  {
    accessorKey: "progress",
    header: "Progress",
    Cell: ({ cell }) => {
      const value = cell.getValue();
      const row = cell.row.original;
      let status;

      if (value === 100) {
        status = (
          <Badge startIcon={<Check />} variant="success">
            Processed Successfully
          </Badge>
        );
      } else if (value === -1) {
        status = (
          <Badge startIcon={<Error />} variant="error">
            Failed - {row.errorMessage}
          </Badge>
        );
      }

      return (
        <>
          {status}
          {value !== 100 && value !== -1 && (
            <CircularProgressWithLabel value={value} />
          )}
        </>
      );
    },
  },
  {
    accessorKey: "name",
    header: "File Name",
  },
  {
    accessorKey: "size",
    header: "File Size",
    Cell: ({ cell }) => `${(cell.getValue() / 1024).toFixed(2)} KB`, // Convert size to KB
  },
];
